module.exports = __webpack_public_path__ + "c1454df72beffe5135409ec4d97b362e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/lankenau06.jpg
// module id = 803
// module chunks = 0